import userManagementReducer from './reducers';

export { default as userManagementActions } from './actions';
export { default as userManagementSelectors } from './selectors';

export default userManagementReducer;
